// Webhook delivery telemetry surfaced to businesses in the dashboard.
//
// These mirror the server response contracts shipped in afriex-server#4962
// (delivery list) and #4963 (delivery detail). They are intentionally
// redeclared here rather than imported from the server package: the server
// keeps its own internal interfaces, and core is where the web client reads
// shared API DTOs from (see BusinessDeveloperSettings). Keep field names in
// sync with the server when either contract changes.
// The webhook event names a business can receive / filter deliveries by.
// Mirrors the server-side BusinessWebHookEvent enum.
export var BusinessWebhookDeliveryEvent;
(function (BusinessWebhookDeliveryEvent) {
    BusinessWebhookDeliveryEvent["CustomerCreated"] = "CUSTOMER.CREATED";
    BusinessWebhookDeliveryEvent["CustomerUpdated"] = "CUSTOMER.UPDATED";
    BusinessWebhookDeliveryEvent["CustomerDeleted"] = "CUSTOMER.DELETED";
    BusinessWebhookDeliveryEvent["PaymentMethodCreated"] = "PAYMENT_METHOD.CREATED";
    BusinessWebhookDeliveryEvent["PaymentMethodUpdated"] = "PAYMENT_METHOD.UPDATED";
    BusinessWebhookDeliveryEvent["PaymentMethodDeleted"] = "PAYMENT_METHOD.DELETED";
    BusinessWebhookDeliveryEvent["TransactionCreated"] = "TRANSACTION.CREATED";
    BusinessWebhookDeliveryEvent["TransactionUpdated"] = "TRANSACTION.UPDATED";
    BusinessWebhookDeliveryEvent["CheckoutSessionCreated"] = "CHECKOUT_SESSION.CREATED";
    // An entity-submitted pool deposit whose proof of payment an operator could
    // not match against the bank inflow. There is deliberately no matching
    // APPROVED event: approval settles the deposit, which already fires
    // TransactionCreated, and a second event would have integrators dedupe.
    BusinessWebhookDeliveryEvent["PoolDepositRequestRejected"] = "POOL_DEPOSIT_REQUEST.REJECTED";
})(BusinessWebhookDeliveryEvent || (BusinessWebhookDeliveryEvent = {}));
//# sourceMappingURL=BusinessWebhookDelivery.js.map